const riot = require('riot');

riot.tag2('page-debug-redirect', '<div class="container p32"> <h2>リダイレクトのテスト</h2> </div>', '', '', function(opts) {
    this.preload = ({req, res}) => {
      console.log('debug ページにリダイレクトします!');
      res.redirect(301, '/debug');
    };
});